import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const SustainabilityPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  environmentalOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Sustainability_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Sustainability Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Commitment</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to conducting business in an environmentally responsible manner, minimising our environmental impact and promoting sustainable practices throughout our operations.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and operations across all sites and activities.
      </p>

      <h4 className="section-title">3. Environmental Management</h4>
      <ul>
        <li>Implementing practices to reduce waste, conserve water, and minimise energy consumption.</li>
        <li>Ensuring compliance with all environmental legislation and regulations.</li>
        <li>Promoting the use of sustainable materials and suppliers.</li>
      </ul>

      <h4 className="section-title">4. Carbon Footprint Reduction</h4>
      <ul>
        <li>Monitoring and reducing greenhouse gas emissions through efficient fleet management and alternative fuel use.</li>
        <li>Encouraging low-emission travel options and supporting carbon offset initiatives.</li>
      </ul>

      <h4 className="section-title">5. Waste Management</h4>
      <p className="section-content">
        Adopting recycling and waste reduction programmes, and ensuring responsible disposal of hazardous materials.
      </p>

      <h4 className="section-title">6. Employee Engagement</h4>
      <p className="section-content">
        Encouraging all employees to participate in sustainability initiatives and fostering a culture of environmental responsibility.
      </p>

      <h4 className="section-title">7. Continuous Improvement</h4>
      <p className="section-content">
        Regularly reviewing environmental performance and sustainability goals to enhance effectiveness and adapt to evolving best practices.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <p><strong>Environmental Officer:</strong> {environmentalOfficerContact || "[Insert Contact]"}</p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will support the Sustainability Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default SustainabilityPolicy;
